import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const oan = {
    jpath: ['spectra', 'oan'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default oan;
//# sourceMappingURL=oan.js.map